import { render, staticRenderFns } from "./ProxyIncomeDetail.vue?vue&type=template&id=4d718cd4&scoped=true&"
import script from "./ProxyIncomeDetail.vue?vue&type=script&lang=js&"
export * from "./ProxyIncomeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d718cd4",
  null
  
)

export default component.exports